import { CircularProgress, Typography } from "@mui/material";
import { loginRequest } from "auth/microsoft";
import { AlertHelper } from "helpers";
import { EAlertType } from "helpers/alertHelper";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { IdentityActions } from "redux/actions";
import {
  useAppDispatch,
  useAppSelector,
} from "redux/configurations/reduxHooks";
import { RootReducer } from "redux/configurations/rootReducer";

const Logout = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  useEffect(() => {
    localStorage.clear();
    history.replace("/login");
    dispatch(IdentityActions.logout.request());
  }, []);
  return (
    <div
      style={{
        flex: 1,
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <CircularProgress
        color={"primary"}
        style={{
          marginBottom: 20,
        }}
      />
      <Typography>Đang đăng xuất</Typography>
    </div>
  );
};

export default Logout;
